const FONT_FAMILY = ["Nunito Sans", "Segoe UI", "Roboto", "Helvetica", "Arial", "sans-serif"].join(",");

export const typography = () => ({
  fontFamily: FONT_FAMILY,
  fontSize: 12,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  h1: {
    fontFamily: FONT_FAMILY,
    fontSize: 40,
    fontWeight: 500,
    lineHeight: 1.2,
    letterSpacing: "-0.01562em",
  },
  h2: {
    fontFamily: FONT_FAMILY,
    fontSize: 32,
    fontWeight: 500,
    lineHeight: 1.2,
    letterSpacing: "-0.00833em",
  },
  h3: {
    fontFamily: FONT_FAMILY,
    fontSize: 24,
    fontWeight: 500,
    lineHeight: 1.2,
    letterSpacing: "0em",
  },
  h4: {
    fontFamily: FONT_FAMILY,
    fontSize: 20,
    fontWeight: 500,
    lineHeight: 1.2,
    letterSpacing: "0.00735em",
  },
  h5: {
    fontFamily: FONT_FAMILY,
    fontSize: 16,
    fontWeight: 500,
    lineHeight: 1.2,
    letterSpacing: "0em",
  },
  h6: {
    fontFamily: FONT_FAMILY,
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 1.2,
    letterSpacing: "0.0075em",
  },
  subtitle1: {
    fontFamily: FONT_FAMILY,
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.75,
    letterSpacing: "0.00938em",
  },
  subtitle2: {
    fontFamily: FONT_FAMILY,
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 1.57,
    letterSpacing: "0.00714em",
  },
  body1: {
    fontFamily: FONT_FAMILY,
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: "0.00938em",
  },
  body2: {
    fontFamily: FONT_FAMILY,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 1.43,
    letterSpacing: "0.01071em",
  },
  button: {
    fontFamily: FONT_FAMILY,
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 1.75,
    letterSpacing: "0.02857em",
    textTransform: "uppercase",
  },
  caption: {
    fontFamily: FONT_FAMILY,
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 1.66,
    letterSpacing: "0.03333em",
  },
  overline: {
    fontFamily: FONT_FAMILY,
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 2.66,
    letterSpacing: "0.08333em",
    textTransform: "uppercase",
  },
  tiny: {
    fontFamily: FONT_FAMILY,
    fontSize: 9,
    fontWeight: 400,
    lineHeight: 2.66,
    letterSpacing: "0.08333em",
    textTransform: "uppercase",
  },
});
